class LocalizationSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const form = this.querySelector('form');
    const select = this.querySelector('select');

    // Automatically submit the form on-change, without the need for a submit button.
    select.addEventListener('change', () => {
      form.submit();
    });
  }
}

customElements.get('localization-selector') ||
  customElements.define('localization-selector', LocalizationSelector);
